import lodashOmit from 'lodash-es/omit';

// Query parameters that carry a credential (login magic links, publication approval link): what the page hands to
// third parties, the support chat or the analytics, never includes them.
const CREDENTIAL_QUERY_PARAMS = ['t', 'token', 'loginExchangeToken', 'verificationToken'];

type UseFullPathWithoutCredentialsReturn = {
    /** The current path and query, without the credential parameters and without the hash. */
    fullPathWithoutCredentials: ComputedRef<string>;
};

export const useFullPathWithoutCredentials = (): UseFullPathWithoutCredentialsReturn => {
    const route = useRoute();
    const router = useRouter();

    const fullPathWithoutCredentials = computed(
        () => router.resolve({ path: route.path, query: lodashOmit(route.query, CREDENTIAL_QUERY_PARAMS) }).fullPath
    );

    return { fullPathWithoutCredentials };
};
